import { sha256 } from "js-sha256";
import cdnBaseUrl from "../../Cdn";

const associaImmagineENomeANomeUtente = function (
  nomeUtente,
  utenteAttuale,
  size,
) {
  //TODO HA ANCORA SENSO QUESTO O SI PUO' PRENDERE TUTTO DA DATABASE?

  let pathImmagine = false;
  let nomeDisplay = nomeUtente;

  if (!size) {
    size = 100;
  }

  //console.log("nomeUtente, utenteAttuale",nomeUtente, utenteAttuale)

  let utenteCheApprezza = false;

  const utentiCheApprezzano = [
    "c.ribero@vigliettisport.com",
    "d.fenoglio@vigliettisport.com",
    "m.borgna@vigliettisport.com",
    "t.robaldo@vigliettisport.com",
    /* "a.ricchetti@jollysport.it", */
    "g.gottardo@vigliettisport.com",
    "m.minazzo@vigliettisport.com",
    "a.gallesio@vigliettisport.com",
    "gaia.61360@gmail.com",
  ];

  if (utentiCheApprezzano.includes(utenteAttuale)) {
    utenteCheApprezza = true;
    switch (nomeUtente) {
      case "c.ribero@vigliettisport.com":
        pathImmagine =
          `${cdnBaseUrl}/images/vs-translations/cinzia.png`;
        nomeDisplay = "ribes";
        break;
      case "d.fenoglio@vigliettisport.com":
      case "damiano.fenoglio@gmail.com":
      case "damiano.vigliettisport@gmail.com":
        pathImmagine =
          `${cdnBaseUrl}/images/vs-translations/dam.png`;
        nomeDisplay = "dam";
        break;
      case "d.sclavo@vigliettisport.com":
      case "domenico.sclavo@gmail.com":
        pathImmagine =
          `${cdnBaseUrl}/images/vs-translations/dome.png`;
        nomeDisplay = "dome";
        break;
      case "m.borgna@vigliettisport.com":
        pathImmagine =
          `${cdnBaseUrl}/images/vs-translations/manu.png`;
        nomeDisplay = "manu";
        break;
      case "t.robaldo@vigliettisport.com":
        pathImmagine =
          `${cdnBaseUrl}/images/vs-translations/tom100.png`;
        nomeDisplay = "tom";
        break;
      case "d.scarcella@vigliettisport.com":
        pathImmagine =
          `${cdnBaseUrl}/images/vs-translations/davide100.png`;
        nomeDisplay = "davide";
        break;
      case "vigliettisport.pratonevoso@gmail.com":
        //pathImmagine = `${cdnBaseUrl}/images/vs-translations/netflixYellow100.png`
        nomeDisplay = "vs gmail";
        break;
      case "c.zazza@vigliettisport.com":
        //pathImmagine = `${cdnBaseUrl}/images/vs-translations/netflixYellow100.png`
        nomeDisplay = "zazza";
        break;
      case "a.ricchetti@jollysport.it":
        pathImmagine =
          `${cdnBaseUrl}/images/vs-translations/andrea100.png`;
        nomeDisplay = "andrea";
        break;
      case "m.tachis@jollysport.it":
        pathImmagine =
          `${cdnBaseUrl}/images/vs-translations/martina.png`;
        nomeDisplay = "martina";
        break;
      case "g.gottardo@vigliettisport.com":
        //pathImmagine = `${cdnBaseUrl}/images/vs-translations/netflixYellow100.png`
        nomeDisplay = "giacomo";
        break;
      case "m.minazzo@vigliettisport.com":
        //pathImmagine = `${cdnBaseUrl}/images/vs-translations/netflixYellow100.png`
        nomeDisplay = "mari";
        break;
      case "a.gallesio@vigliettisport.com":
        pathImmagine =
          `${cdnBaseUrl}/images/vs-translations/andreag.jpg`;
        nomeDisplay = "chicco";
        break;
      case "gaia.61360@gmail.com":
        //pathImmagine = `${cdnBaseUrl}/images/vs-translations/netflixYellow100.png`
        nomeDisplay = "gaia";
        break;
      case "notaPreEsistente":
        pathImmagine =
          `${cdnBaseUrl}/images/vs-translations/catstudying.jpg`;
        nomeDisplay = "Anziano Gatto detentore del sapere";
        break;
      case "notaAutomatica":
        pathImmagine =
          `${cdnBaseUrl}/images/vs-translations/swagCat.jpg`;
        nomeDisplay = "Attento Gatto ImportaOrdini";
        break;
      case "notaCambioStatoPS":
        pathImmagine =
          `${cdnBaseUrl}/images/vs-translations/gattoCorrieri.png`;
        nomeDisplay = "Gatto dei cambi stato PS";
        break;
      case "notaGiacenze":
        pathImmagine =
          `${cdnBaseUrl}/images/vs-translations/magCat2.jpeg`;
        nomeDisplay = "Solerte Gatto Magazziniere";
        break;
      case "notaRitiroNegozio":
        pathImmagine =
          `${cdnBaseUrl}/images/vs-translations/psCat.jpg`;
        nomeDisplay = "Premurosa Gatta Personal Shopper";
        break;
      default:
        break;
    }
  } else {
    switch (nomeUtente) {
      case "c.ribero@vigliettisport.com":
        pathImmagine =
          `${cdnBaseUrl}/images/vs-translations/cinzia100.png`;
        nomeDisplay = "Cinzia R.";
        break;
      case "d.fenoglio@vigliettisport.com":
      case "damiano.fenoglio@gmail.com":
      case "damiano.vigliettisport@gmail.com":
        pathImmagine =
          `${cdnBaseUrl}/images/vs-translations/dam100.png`;
        nomeDisplay = "Damiano";
        break;
      case "d.sclavo@vigliettisport.com":
      case "domenico.sclavo@gmail.com":
        pathImmagine =
          `${cdnBaseUrl}/images/vs-translations/dome.png`;
        nomeDisplay = "Domenico";
        break;
      case "m.borgna@vigliettisport.com":
        pathImmagine =
          `${cdnBaseUrl}/images/vs-translations/manu100.png`;
        nomeDisplay = "Manuela";
        break;
      case "t.robaldo@vigliettisport.com":
        //pathImmagine = `${cdnBaseUrl}/images/vs-translations/netflixYellow100.png`
        nomeDisplay = "Tommaso";
        break;
      case "d.scarcella@vigliettisport.com":
        pathImmagine =
          `${cdnBaseUrl}/images/vs-translations/davide100.png`;
        nomeDisplay = "Davide";
        break;
      case "vigliettisport.pratonevoso@gmail.com":
        //pathImmagine = `${cdnBaseUrl}/images/vs-translations/netflixYellow100.png`
        nomeDisplay = "vs gmail";
        break;
      case "c.zazza@vigliettisport.com":
        //pathImmagine = `${cdnBaseUrl}/images/vs-translations/netflixYellow100.png`
        nomeDisplay = "Cinzia Z.";
        break;
      case "a.ricchetti@jollysport.it":
        pathImmagine =
          `${cdnBaseUrl}/images/vs-translations/andrea100.png`;
        nomeDisplay = "Andrea R.";
        break;
      case "m.tachis@jollysport.it":
        pathImmagine =
          `${cdnBaseUrl}/images/vs-translations/martina.png`;
        nomeDisplay = "Martina";
        break;
      case "g.gottardo@vigliettisport.com":
        //pathImmagine = `${cdnBaseUrl}/images/vs-translations/netflixYellow100.png`
        nomeDisplay = "Giacomo";
        break;
      case "notaPreEsistente":
        pathImmagine =
          `${cdnBaseUrl}/images/vs-translations/bot.png`;
        nomeDisplay = "";
        break;
      case "notaAutomatica":
        pathImmagine =
          `${cdnBaseUrl}/images/vs-translations/bot.png`;
        nomeDisplay = "Nota automatica";
        break;
      case "notaCambioStatoPS":
        pathImmagine =
          `${cdnBaseUrl}/images/vs-translations/bot.png`;
        nomeDisplay = "notaCambioStatoPS";
        break;
      case "notaRitiroNegozio":
        pathImmagine =
          `${cdnBaseUrl}/images/vs-translations/bot.png`;
        nomeDisplay = "Nota ritiro negozio";
        break;
      case "notaGiacenze":
        pathImmagine =
          `${cdnBaseUrl}/images/vs-translations/bot.png`;
        nomeDisplay = "Giacenze";
        break;
      case "a.gallesio@vigliettisport.com":
        pathImmagine =
          `${cdnBaseUrl}/images/vs-translations/andreag.jpg`;
        nomeDisplay = "Andrea G.";
        break;
      case "m.minazzo@vigliettisport.com":
        //pathImmagine = `${cdnBaseUrl}/images/vs-translations/netflixYellow100.png`
        nomeDisplay = "Mariavittoria";
        break;
      default:
        pathImmagine = false;
        break;
    }
  }

  if (
    nomeUtente !== "notaAutomatica" &&
    nomeUtente !== "notaPreEsistente" &&
    nomeUtente !== "notaCambioStatoPS"
  ) {
    const hash = sha256(String(nomeUtente).trim().toLowerCase());
    const params = new URLSearchParams({
      d: pathImmagine ? pathImmagine : "retro",
      s: size,
    });
    const url = `https://www.gravatar.com/avatar/` + hash + "?" + params;
    pathImmagine = url;
  }

  return {
    pathImmagine: pathImmagine,
    nomeDisplay: nomeDisplay,
    utenteCheApprezza: utenteCheApprezza,
  };
};

export default associaImmagineENomeANomeUtente;
